import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppSettings } from "../../app.settings";
import { BasePromotionService } from "common";


@Injectable({
  providedIn: "root",
})
export class PromotionService extends BasePromotionService {
  constructor(
    settings: AppSettings,
    http: HttpClient,
  ) {
    super(http, settings.promotions.url);
  }
}
